<template>
  <div
    class="l_container"
    v-bind:class="{ premium: this.news.target_user_type !== '0' }"
    v-if="news"
  >
    <div
      v-if="this.news.target_user_type !== '0' && is_iPhone()"
      class="backBtn"
      @click="closePage()"
    >
      <img src="@/assets/img/buttons/backBtn.png" />
    </div>
    <div class="l_header">
      <p class="c_title" v-html="news.caption"></p>
      <div class="l_grid">
        <div class="l_left">
          <p class="c_date"></p>
        </div>
        <div class="l_right">
          <img
            class="c_label"
            :src="
              require('@/assets/img/label/' +
                this.categories[this.news.category_id] +
                cat_color)
            "
          />
        </div>
      </div>
    </div>
    <div class="l_contents">
      <template v-if="this.news.detail_image_url !== ''">
        <div class="l_image__main">
          <img class="c_img" :src="this.news.detail_image_url" />
        </div>
      </template>
      <div class="l_subtitle">
        <template v-if="news.is_html_display === '0'">
          <p class="c_subtitle">{{ this.news.subtitle }}</p>
        </template>
        <template v-if="news.is_html_display === '1'">
          <p class="c_subtitle" v-html="this.news.subtitle"></p>
        </template>
      </div>
      <template v-if="this.news.external_url !== ''">
        <div class="l_button__external">
          <UIButton :label="this.news.external_url_label" @click="tapAction" />
        </div>
      </template>
    </div>
    <VersionCheck :show="walkAlert" :on-close="closeAlert" :msg="errorMsg" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UIButton from '@/components/UIButton'
import VersionCheck from '../FAQWalkVersionCheck'

import { FactoryTrack } from '../../constant/firebase'
export default {
  name: 'HomeDetail',
  components: {
    UIButton,
    VersionCheck
  },
  data: function() {
    return {
      categories: {
        0: 'info',
        1: 'info',
        2: 'campaign',
        3: 'menu',
        4: 'shop',
        5: 'only-you',
        6: 'tips',
        12: 'info',
        15: 'info'
      },
      news: null,
      walkAlert: false,
      errorMsg:
        'ウォーク機能はアプリバージョン4.0.0以上対応です。<br />最新版のアプリにアップデートしてください。'
    }
  },
  created() {
    // isFixedを解除する
    this.action_ToggleModal(false)
    // 同一ページでリロード対策に、詳細データはLocalStorageにも保存する
    if (!this.data) {
      this.news = JSON.parse(window.localStorage.getItem('home-detail'))
    } else {
      this.news = this.data
      window.localStorage.setItem('home-detail', JSON.stringify(this.data))
    }
    if (this.news) {
      document.title = this.news.caption
    }
  },
  computed: {
    ...mapGetters({
      data: 'Home/detailNews'
    }),
    cat_color: function() {
      return this.news.target_user_type !== '0' ? '_white.svg' : '.svg'
    }
  },
  methods: {
    ...mapActions('Modal', ['action_ToggleModal']),
    ...mapActions('Native', [
      'actionRequestExternalLink',
      'actionCallCloseNewsDetail',
      'actionOpenAboutWalk',
      'actionVer4_1',
      'actionVer4_2',
      'actionVer4_3',
      'actionVer6_1'
    ]),
    ...mapActions('Analytics', ['trackEvent']),
    tapAction: async function() {
      console.log(this.news)
      this.trackEvent(
        FactoryTrack.createInfoNewsExternalLink(this.news.id, this.news.caption)
      )
      const link = this.news.external_url
      if (link.startsWith('walk') || link === 'frbbscreen://faqwalk') {
        this.walkAlert = await this.actionOpenAboutWalk()
        this.errorMsg =
          'ウォーク機能はアプリバージョン4.0.0以上対応です。<br />最新版のアプリにアップデートしてください。'
      } else if (
        [
          'frbbscreen://walk',
          'frbbscreen://menu',
          'frbbscreen://search',
          'frbbscreen://ranking',
          'frbbscreen://home',
          'frbbscreen://coupon'
        ].includes(link)
      ) {
        this.walkAlert = await this.actionVer4_1()
        this.errorMsg =
          'このボタンはアプリバージョン4.1.0以上対応です。<br />最新版のアプリにアップデートしてください。'
        if (this.walkAlert === 0) {
          this.actionRequestExternalLink(link)
        }
      } else if (['frbbscreen://logbo'].includes(link)) {
        this.walkAlert = await this.actionVer4_2()
        this.errorMsg =
          'このボタンはアプリバージョン4.2.0以上対応です。<br />最新版のアプリにアップデートしてください。'
        if (this.walkAlert === 0) {
          this.actionRequestExternalLink(link)
        }
      } else if (['frbbscreen://seal'].includes(link)) {
        this.walkAlert = await this.actionVer6_1()
        this.errorMsg =
          'このボタンはアプリバージョン6.1.0以上対応です。<br />最新版のアプリにアップデートしてください。'
        if (this.walkAlert === 0) {
          this.actionRequestExternalLink(link)
        }
      } else if (
        [
          'frbbscreen://friendtop',
          'frbbscreen://linetop',
          'frbbscreen://weborder?page=takeout',
          'frbbscreen://weborder?page=netstore',
          'frbbscreen://weborder?page=etc',
          'frbbscreen://shops',
          'frbbscreen://appletop'
        ].includes(link)
      ) {
        this.walkAlert = await this.actionVer4_3()
        this.errorMsg =
          'このボタンはアプリバージョン4.3.0以上対応です。<br />最新版のアプリにアップデートしてください。'
        if (this.walkAlert === 0) {
          this.actionRequestExternalLink(link)
        }
      } else {
        this.actionRequestExternalLink(link)
      }
    },
    closeAlert: function() {
      this.trackEvent(FactoryTrack.createVersionCheckClose())
      this.walkAlert = 0
    },
    async closePage() {
      this.$router.go(-1)
    },
    is_iPhone() {
      var userAgent = window.navigator.userAgent.toLowerCase()
      if (
        userAgent.indexOf('iphone') != -1 ||
        userAgent.indexOf('ipad') != -1
      ) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.premium {
  .l_header,
  .l_button__external .c_button {
    background-color: #0c0934;
  }
}

.l_container {
  padding: 20px 10px;
  background-color: #ffffff;
  height: 100%;
  overflow: scroll;
}

.l_header {
  background-color: #602209;
  text-align: left;
  padding: 10px 15px;
  position: relative;
}

.l_grid {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.l_left {
  width: 100%;
  text-align: left;
  vertical-align: bottom;
}

.l_right {
  width: 100%;
  text-align: right;
}

.l_contents {
  margin-top: 10px;
}

.l_subtitle {
  margin-top: 10px;
}
.backBtn {
  margin-bottom: 10px;
  margin-left: 0px;
  text-align: left;
}
.backBtn img {
  width: 40%;
}

.l_button__external {
  width: 250px;
  margin: 20px auto 0;
}

.c_title {
  color: #ffffff;
  font-family: 'HiraKakuPro-W6';
  font-size: 16px;
  line-height: 1.38;
  letter-spacing: normal;
}

.c_date {
  color: #ffffff;
  font-size: 10px;
  line-height: 1;
}

.c_label {
  width: 74px;
  height: 20px;
  vertical-align: bottom;
}

.c_subtitle {
  font-size: 12px;
  line-height: 1.75;
  text-align: left;
  white-space: pre-wrap;
}

.c_img {
  width: 100%;
  max-width: 100%;
}
</style>
